/*
 * Copyright (c) 2024 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {useSelector} from 'react-redux';
import {useHasMounted} from '@ion/core/src/hooks/useHasMounted';
import OperationalLayers from '@ion/dls/src/maps/layers/OperationalLayers';
import {MapContainerProps} from '@ion/dls/src/maps/types/types';
import {mapLayerSelector} from '@/store/selectors/tracking-selectors';
import useOperationalLayerProps from '../hooks/useOperationalLayerProps';

const OperationalLayerContainer = ({map, view}: MapContainerProps) => {
  const isMounted              = useHasMounted(null as any);
  const layers                 = useSelector(mapLayerSelector);
  const operationalLayersProps = useOperationalLayerProps();
    
  if (isMounted) {
    return (
      <OperationalLayers map={map}
        view={view}
        layers={layers}
        isTracking2Page={true}
        operationalLayersProps={operationalLayersProps as any} />
    );
  }
};
export default OperationalLayerContainer;
